// @flow

import type { Player$PlaylistMode } from '../types/Playlist';

export const BOTTOM_MODE: Player$PlaylistMode = 'bottom';
export const RIGHT_MODE: Player$PlaylistMode  = 'right';
export const AUTO_MODE: Player$PlaylistMode   = 'auto';

export const PLAYLIST_MODES  = [ AUTO_MODE, BOTTOM_MODE, RIGHT_MODE ];
